<template>
  <div id="app">
    <commonHeader />
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>
<script>
import commonHeader from '@/components/header'
export default {
  components: {
    commonHeader
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* width: 100%;
  height: 100%; */
  /* height: 724px; */
  width: 375px;
  max-width: 375px;
  box-sizing: border-box;
  /* border: 1px solid #000; */
  padding: 0 24px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: url("./assets/bg.png") no-repeat;
  background-size: 100%;
  /* padding: 0 24px; */
  overflow: hidden;
   font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif Alibaba PuHuiTi-Medium;
   /* height: 1111px; */
}

nav {
  /* padding: 30px; */
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
